//
//installation_identifier
/**
 * @ngdoc Service
 */
(function() {
    'use strict';

    angular.module('vrm.core')
        .service('AddInstallationService', AddInstallationService);

    /**
     * @constructor
     * @ngInject
     */
    function AddInstallationService($log, ApiService, InstallationsService, locale, vrmNotificationsService, vrmNotificationType) {

        /* Public API */
        var service = {
            model: {
                installation_identifier: null
            },
            addInstallation: addInstallation,
            uploadCCGXcallback: uploadCCGXcallback
        };

        return service;

        /* Private */

        function addInstallation() {
            const payload = { ...service.model }
            if (payload.selectedCurrency && payload.selectedCurrency.code) {
                // check if it's shs and requires paygoCurrency by checking if paygoPrivateKey is available
                if (payload.paygoPrivateKey) {
                    payload.paygoCurrency = payload.selectedCurrency.code;
                }
                delete payload.selectedCurrency;
            }
            return ApiService.users('addsite', payload, true)
                .then(function(response) {
                    if (!response.data.success) {
                        if (response.data.error_code === 'installation_already_bound_to_account') {
                            service.model.installation_identifier = null;
                            locale.ready('common').then(function() {
                                var message = locale.getString('addinstallation.INSTALLATION_ALREADY_BOUND_TO_ACCOUNT');

                                vrmNotificationsService.add({type: vrmNotificationType.INFO, message: message, timeout: 20000});

                                // Redirect user to the site they already have access to
                                InstallationsService.getInstallation(response.data.idSite).then(function (installation) {
                                        InstallationsService.redirectToInstallation(installation);
                                });

                            });
                        }
                        else if (response.data.error_code === 'installation_identifier_unknown' || response.data.error_code === 'validation_error') {
                            vrmNotificationsService.add({type: vrmNotificationType.ERROR, message: locale.getString('addinstallation.INSTALLATION_IDENTIFIER_UNKNOWN')}, true);
                        }
                        else if (response.data.error_code === 'wifi_mac_conflict') {
                            vrmNotificationsService.add({type: vrmNotificationType.ERROR, message: locale.getString('addinstallation.INSTALLATION_IDENTIFIER_WIFI_MAC_CONFLICT')}, true);
                        }
                        else if (response.data.error_code === 'admin_mail_sent') {
                            service.model.installation_identifier = null;
                            vrmNotificationsService.add({type: vrmNotificationType.INFO, message: locale.getString('addinstallation.INSTALLATION_ADMIN_MAIL_SENT'), timeout: 20000});
                            return response.data;
                        }
                        else if (response.data.error_code === 'pending_request_exists') {
                            service.model.installation_identifier = null;
                            vrmNotificationsService.add({type: vrmNotificationType.INFO, message: locale.getString('addinstallation.INSTALLATION_PENDING_REQUEST_EXISTS'), timeout: 20000});
                            return response.data;
                        }
                        else if (response.data.error_code === 'site_request_limit_reached') {
                            service.model.installation_identifier = null;
                            vrmNotificationsService.add({type: vrmNotificationType.ERROR, message: locale.getString('addinstallation.SITE_REQUEST_LIMIT_REACHED')}, true);
                            return response.data;
                        }
                        else if (response.data.error_code === 'too_many_requests') {
                            service.model.installation_identifier = null;
                            vrmNotificationsService.add({type: vrmNotificationType.ERROR, message: locale.getString('addinstallation.INSTALLATION_TOO_MANY_REQUESTS')}, true);
                            return response.data;
                        }
                    } else {
                        service.model.installation_identifier = null;
                        vrmNotificationsService.add({type: vrmNotificationType.SUCCESS, message: locale.getString('addinstallation.INSTALLATION_ADDED')});

                        //Reload installations list
                        InstallationsService.reload();
                    }

                    return response.data;
                });
        }

        function uploadCCGXcallback(files) {
            locale.ready('dashboard').then(function() {
                if (!files && files.length !== 1) return;
                const file = files[0];

                // Check the file size before sending it to prevent entity too large (413) from ngnix.
                if (file.size > 200 * Math.pow(10, 6)) {
                    vrmNotificationsService.add(
                        {
                            type: vrmNotificationType.ERROR,
                            message: locale.getString('dashboard.ccgx_file_too_big'),
                        },
                        true,
                    );
                    return;
                }

                var uploadingNotification = vrmNotificationsService.add({
                    type: vrmNotificationType.INFO,
                    timeout: 5 * 60 * 1000, // 5 minutes
                    message: locale.getString('dashboard.ccgx_uploading'),
                });

                let data = new FormData();

                data.append('data', file);

                function processResponse(response) {
                    const messageTimeout = 60 * 1000; // 1 minute
                    vrmNotificationsService.remove(uploadingNotification);
                    if (response && response.data && response.data.success) {
                        vrmNotificationsService.add({
                            type: vrmNotificationType.SUCCESS,
                            timeout: messageTimeout,
                            message: locale.getString('dashboard.ccgx_uploaded'),
                        });
                    } else if (response && response.data && response.data.errors) {
                        locale.ready('core').then(function() {
                            vrmNotificationsService.add({
                                type: vrmNotificationType.ERROR,
                                message: ApiService.formatErrors(response),
                                timeout: messageTimeout,
                            });
                        });
                    } else {
                        vrmNotificationsService.add({
                            type: vrmNotificationType.ERROR,
                            message: locale.getString('dashboard.ccgx_upload_error'),
                            timeout: messageTimeout,
                        });
                    }
                }
                ApiService.call2('/installations/data-upload', data, { method: 'POST', skipResultChecks: false }).then(processResponse).catch(processResponse);

            });
        }

    }
})();
